export const getDefaultValuesObj = (mappingFieldsObj) => ({
  bitrixField: { nameId: mappingFieldsObj.bitrixField.nameId },
  optimaField: { nameId: mappingFieldsObj.optimaField.nameId },
});
